import { Component, Host, h, JSX, Prop } from '@stencil/core'

@Component({
    tag: 'zr-rating-summary',
    styleUrl: 'zr-rating-summary.scss',
    shadow: true,
})

/**
 * ZooRoyal ratings component.
 */
export class ZrRatingSummary {
    /**
     * The average product-rating.
     */
    @Prop() average: string

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class="zr-rating__summary">
                    <div class="zr-rating__summary-wrapper">
                        <zr-rating-stars value={this.average}/>
                        <p class="zr-rating__average">
                            {this.average}
                        </p>
                    </div>
                </div>
            </Host>
        )
    }
}
